import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22font.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/fonts/doppler-regular-webfont.woff2%22},{%22path%22:%22../public/fonts/doppler-regular-webfont.woff%22}],%22display%22:%22swap%22,%22fallback%22:[%22Georgia%22,%22serif%22]}],%22variableName%22:%22doppler%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'doppler', 'doppler Fallback', Georgia, serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
